// extracted by mini-css-extract-plugin
export default {"chartTitle":"ChartTitle_chartTitle__CIgp1","colorOrIcon":"ChartTitle_colorOrIcon__+SE3X","icon":"ChartTitle_icon__GV1uM","title":"ChartTitle_title__jpIUq"};